exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".log-item[data-v-784e2994]{margin:.5rem 0!important}.input-group label[data-v-784e2994]{width:1000%}.input-group[data-v-784e2994]{margin-bottom:15px}.show-order-header[data-v-784e2994]{margin-top:15px}.log_history .date[data-v-784e2994],.log_permanent .date[data-v-784e2994]{font-size:.8rem;display:block;font-weight:700}.log_history .message[data-v-784e2994],.log_permanent .message[data-v-784e2994]{font-size:1rem;display:block}.log_history .app[data-v-784e2994],.log_permanent .app[data-v-784e2994]{font-size:.8rem;display:block}.teste[data-v-784e2994]{display:none}.list-group .list-group-item[data-v-784e2994]{border-radius:0}.list-group:first-of-type .list-group-item[data-v-784e2994]{border-radius:3px 3px 0 0}.list-group:last-of-type .list-group-item[data-v-784e2994]{border-radius:0 0 3px 3px}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-784e2994","scoped":true,"hasInlineConfig":true}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./resources/assets/js/components/Orders/ShowOrder.vue
// module id = vcmk
// module chunks = 0